import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

export function OwnedGroupSelectBox({ ownedGroups, setTargetGroup }) {
  const handleChange = (event) => {
    let selectedGroupId = event.target.value;
    ownedGroups.forEach((group) => {
      if (group.id == selectedGroupId) {
        setTargetGroup(group);
      }
    });
  };

  let ownedGroupList = null;
  if (ownedGroups != null) {
    ownedGroupList = ownedGroups.map((group, i) => {
      return (
        <MenuItem value={group.id} key={i}>
          {group.Name}
        </MenuItem>
      );
    });
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ mt: 2 }}
    >
      <FormControl sx={{ m: 1, minWidth: 200, maxWidth: 300 }}>
        <InputLabel id="owned-group-select-helper-label">グループ</InputLabel>
        <Select
          labelId="owned-group-select-helper-label"
          id="owned-group-select-helper"
          label="OwnedGroup"
          onChange={handleChange}
          size="small"
        >
          {ownedGroupList}
        </Select>
      </FormControl>
    </Grid>
  );
}

OwnedGroupSelectBox.propTypes = {
  ownedGroups: PropTypes.object,
  setTargetGroup: PropTypes.any,
};
